import * as React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

export const DiscoverSelected = (props: SvgProps) => {
  const { color } = props
  return (
    <Svg fill='none' height='26' viewBox='0 0 26 26' width='26' {...props}>
      <G stroke={color} strokeMiterlimit='10' strokeWidth='4'>
        <Path d='m19 10.5c0 4.6944-3.8056 8.5-8.5 8.5-4.69442 0-8.5-3.8056-8.5-8.5 0-4.69442 3.80558-8.5 8.5-8.5 4.6944 0 8.5 3.80558 8.5 8.5z' />
        <Path d='m17.499 17.501 6.5 6.498' strokeLinecap='round' />
      </G>
    </Svg>
  )
}
